import CookieManager from '@/helpers/cookiemanager'
import Config from '@/config'
import { FootballMatch } from '@/models/match'
import { CricketMatch } from '@/models/cricket/match'
import Utils from '@/utils'
import io from 'socket.io-client'

let footballPushConnection = null
let cricketPushConnection = null
let socketProxyConnection = null

export class PushConnection {
  constructor () {
    this.pendingListen = []
    this.listening = []
    this.connected = false
    this.callbacks = {}

    this.enableMinuteUpdate = false
    this.minutesCallbacks = {}
    this.minuteUpdateId = null

    const token = CookieManager.getItem('rzAccessToken')
    if (!token) {
      console.log('Token missing to connect')
      return null
    }

    this.connection = this.buildPushConnection(token)
  }

  getSocketPath () {
    return null
  }

  buildPushConnection (token) {
    return null
  }

  onAuthenticated () {
    this.connected = true
    if (this.enableMinuteUpdate) {
      this.minuteUpdateId = setInterval(() => {
        this.onMinuteUpdate()
      }, 1000 * 20)
    }
    if (this.pendingListen.length > 0) {
      let key = this.pendingListen.pop()
      while (key) {
        this.connectMatch(key)
        key = this.pendingListen.pop()
      }
    }
  }

  onMinuteUpdate () {
    Object.keys(this.minutesCallbacks).forEach((id) => {
      this.minutesCallbacks[id]()
    })
  }

  onMatchJoined (key) {
    console.log('Match Connected', key)
  }

  onMatchUpdate (key, match) {
    const cbs = this.callbacks[key]
    if (cbs) {
      Object.keys(cbs).forEach((id) => {
        // console.log('Callling', id, cbs)
        cbs[id](match)
      })
    }
  }

  listenMatch (key, matchUpdateFn, minuteUpdateFn) {
    if (!this.callbacks[key]) {
      this.callbacks[key] = {}
    }

    const id = Utils.uniqueId()
    this.callbacks[key][id] = matchUpdateFn
    if (minuteUpdateFn) {
      this.minutesCallbacks[id] = minuteUpdateFn
    }

    if (this.connected) {
      this.connectMatch(key)
    } else {
      this.pendingListen.push(key)
    }

    return id
  }

  connectMatch (key) {
    this.listening.push(key)
  }

  removeMatch (key) {

  }

  stopMatchUpdate (key, id) {
    console.log('Remove', id)
    this.removeMatch(key)
    if (this.callbacks[key] && this.callbacks[key][id]) {
      delete this.callbacks[key][id]
      delete this.minutesCallbacks[id]
    }
  }
}

export class FootballPushConnection extends PushConnection {
  getSocketPath () {
    return Config.FootballPushEndpoint
  }

  buildPushConnection (token) {
    this.enableMinuteUpdate = true
    let pushConnection = io(this.getSocketPath())
    pushConnection.emit('auth', { token })
    pushConnection.on('authenticated', () => {
      this.onAuthenticated()
    })

    pushConnection.on('football_match_joined', (data) => {
      super.onMatchJoined(data)
    })

    pushConnection.on('football_match_update', (data) => {
      // console.log('Got push update')
      const match = FootballMatch.createFromJson(data.match)
      this.onMatchUpdate(match.info.key, match)
    })

    return pushConnection
  }

  connectMatch (key) {
    super.connectMatch(key)
    this.connection.emit('football_match_connect', key)
  }
}

export class CricketPushConnection extends PushConnection {
  getSocketPath () {
    return Config.CricketPushEndpoint
  }

  buildPushConnection (token) {
    let pushConnection = io(this.getSocketPath())
    pushConnection.emit('auth', { token })
    pushConnection.on('authenticated', () => {
      this.onAuthenticated()
    })

    pushConnection.on('cricket_match_joined', (data) => {
      super.onMatchJoined(data)
    })

    pushConnection.on('cricket_match_update', (data) => {
      const match = CricketMatch.createFromJson(data.data.card)
      this.onMatchUpdate(match.key, match)
    })

    return pushConnection
  }

  connectMatch (key) {
    super.connectMatch(key)
    this.connection.emit('cricket_match_connect', key)
  }
}

export class SocketProxyConnection extends CricketPushConnection {
  getSocketPath () {
    return Config.SocketProxyEndpoint
  }
}

export const FootballPush = {
  instance () {
    if (footballPushConnection == null) {
      footballPushConnection = new FootballPushConnection()
    }
    return footballPushConnection
  }
}

export const CricketPush = {
  instance () {
    if (cricketPushConnection == null) {
      cricketPushConnection = new CricketPushConnection()
    }
    return cricketPushConnection
  }
}

export const SocketProxy = {
  instance () {
    if (socketProxyConnection == null) {
      socketProxyConnection = new SocketProxyConnection()
    }
    return socketProxyConnection
  }
}
